<template>
    <div>
        <LoadingVue :isLoading="isLoading" :key="isLoading"/>
        <div :class="view_class_view.div_container_1.container">
            <div>
                <label for="input_zip_code_address">Código Postal:</label>
                <input type="text" id="input_zip_code_address" 
                :maxlength="5"
                v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: _addressModelValidation$.postal_code.$error,
                [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!_addressModelValidation$.postal_code.$invalid,
                [view_class_view.classInputs.default ]: _addressModelValidation$.postal_code.$invalid && !_addressModelValidation$.postal_code.$error  }"
                v-model="addressModel.postal_code"
                @blur="_addressModelValidation$.postal_code.$validate"
                @keyup="searsh_suburb()">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _addressModelValidation$.postal_code.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div :class="view_class_view.div_container_1.div_container_neightboorhood.container">
                <label for="select_neightboorhood_address">Colonia:</label>
                <select id="select_neightboorhood_address" name="select_neightboorhood_address"
                v-model="addressModel.suburb"
                v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: _addressModelValidation$.suburb.$error,
                [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!_addressModelValidation$.suburb.$invalid,
                [view_class_view.classInputs.default ]: _addressModelValidation$.suburb.$invalid && !_addressModelValidation$.suburb.$error  }"
                @blur="_addressModelValidation$.suburb.$validate">
                <option value="" selected disabled >Seleccione una colonia</option>
                <option :value="suburb.nombre.toUpperCase()" v-for="suburb in list_suburb" :key="suburb.id">{{suburb.nombre.toUpperCase()}}</option>
                </select>

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _addressModelValidation$.suburb.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>
        </div>

        <div :class="view_class_view.div_container_2.container">
          <div>
            <label :class="view_class_view.div_container_2.state.label" id="label_state_address_name">Estado:</label>
            <label :class="view_class_view.div_container_2.state.label_information" id="label_state_address">{{addressModel.state.toUpperCase()}}</label>
          </div>
          <div>
            <label :class="view_class_view.div_container_2.municipality.label" id="label_municipality_address_name">Municipio:</label>
            <label :class="view_class_view.div_container_2.municipality.label_information" id="label_municipality_address">{{addressModel.municipality.toUpperCase()}}</label>
          </div>
          <div>
            <label :class="view_class_view.div_container_2.city_address.label" id="label_city_address_name">Ciudad:</label>
            <label :class="view_class_view.div_container_2.city_address.label_information" id="label_city_address" >{{addressModel.city.toUpperCase()}}</label>
          </div>
        </div>


        <div :class="view_class_view.div_container_3.container">
            <div :class="view_class_view.div_container_3.div_container_street.container">
                <label for="input_street_address">Calle:</label>
                <input type="text" id="input_street_address"
                v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: _addressModelValidation$.street.$error,
                [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!_addressModelValidation$.street.$invalid,
                [view_class_view.classInputs.default ]: _addressModelValidation$.street.$invalid && !_addressModelValidation$.street.$error}"
                @blur="_addressModelValidation$.street.$validate"
                v-model="addressModel.street">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _addressModelValidation$.street.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div :class="view_class_view.div_container_3.div_container_exterior_street.container">
                <label for="input_exterior_number_address">Número Exterior:</label>
                <input type="number" id="input_exterior_number_address"
                v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: _addressModelValidation$.ext_number.$error,
                [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!_addressModelValidation$.ext_number.$invalid,
                [view_class_view.classInputs.default ]: _addressModelValidation$.ext_number.$invalid && !_addressModelValidation$.ext_number.$error}"
                @blur="_addressModelValidation$.ext_number.$validate"
                v-model="addressModel.ext_number">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _addressModelValidation$.ext_number.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div :class="view_class_view.div_container_3.div_container_interior_street.container">
                <label for="input_interior_number_address">Número Interior:</label>
                <input type="text" id="input_interior_number_address"
                v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: _addressModelValidation$.int_number.$error,
                [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!_addressModelValidation$.int_number.$invalid,
                [view_class_view.classInputs.default ]: _addressModelValidation$.int_number.$invalid && !_addressModelValidation$.int_number.$error}"
                @blur="_addressModelValidation$.int_number.$validate"
                v-model="addressModel.int_number">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _addressModelValidation$.int_number.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>
        </div>

        <div :class="view_class_view.div_container_4.container">
            <div :class="view_class_view.div_container_4.div_container_between_street_address.container">
                <label for="input_between_street_address">Entre Calle:</label>
                <input type="text" id="input_between_street_address"
                v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: _addressModelValidation$.between_street_one.$error,
                [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!_addressModelValidation$.between_street_one.$invalid,
                [view_class_view.classInputs.default ]: _addressModelValidation$.between_street_one.$invalid && !_addressModelValidation$.between_street_one.$error}"
                @blur="_addressModelValidation$.between_street_one.$validate"
                v-model="addressModel.between_street_one">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _addressModelValidation$.between_street_one.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div :class="view_class_view.div_container_4.div_and_street_address.container">
                <label for="input_and_street_address">Y Calle:</label>
                <input type="text" id="input_and_street_address"
                v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: _addressModelValidation$.between_street_two.$error,
                [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!_addressModelValidation$.between_street_two.$invalid,
                [view_class_view.classInputs.default ]: _addressModelValidation$.between_street_two.$invalid && !_addressModelValidation$.between_street_two.$error}"
                @blur="_addressModelValidation$.between_street_two.$validate"
                v-model="addressModel.between_street_two">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _addressModelValidation$.between_street_two.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>
        </div>
    
        
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import axios from 'axios';
import { ref } from 'vue';
import LoadingVue from './VueLoading.vue';
import Swal from 'sweetalert2';

export default({
    name:"AddressComponent",
    props:{
        validations:{},
        view_class_view:{}
    },
    components:{
        LoadingVue
    },
    setup(props){

        let isLoading = ref(false);

        let addressModel = ref({
            city: "N/A",
            state: "N/A",
            status: "activo",
            street: "",
            suburb: "",
            country: "MÉXICO",
            latitude: "",
            longitude: "",
            ext_number: "",
            int_number: "",
            postal_code: "",
            municipality: "N/A",
            residence_start: "",
            residence_status: "",
            between_street_one: "",
            between_street_two: ""
        });

        const _addressModelValidation$ = useVuelidate(props.validations,addressModel);
        let list_suburb = ref([]);

        function searsh_suburb(){
            if(addressModel.value.postal_code.toString().length != 5){
                return;
            }

            _addressModelValidation$.value.postal_code.$validate();

            if(_addressModelValidation$.value.postal_code.$error){
                return false
            }
            isLoading.value = true;

            const API_URL = `https://anter.com.mx:3001/Api/Catalogo/Sepomex/obtener_colonias`;

            const params = {
                contenido: {
                    codigo_postal: addressModel.value.postal_code.toString(),
                    colonia: ""
                }
            };

            const header = {
                headers:{
                    'Content-Type': 'application/json',
                },
                auth: {
                    username: "multicr",
                    password: "*cabsa2018*",
                }
            }

            axios.post(API_URL,params,header).then( response => {
                // console.log("🚀 ~ file: Address.vue:207 ~ axios.post ~ response", response)

                if(response.data.ERROR){
                    addressModel.value.city = "N/A";
                    addressModel.value.state = "N/A";
                    addressModel.value.municipality = "N/A";
                    list_suburb.value = [];

                    Swal.fire({
                        title: "Aviso",
                        text: "Introduzca un código postal válido",
                        icon: "warning",
                        confirmButtonColor: '#FEB72B',
                    });
                    isLoading.value = false;
                    return false;
                }

                addressModel.value.city = response.data.ciudad.nombre != null ? response.data.ciudad.nombre : "N/A";
                addressModel.value.state = response.data.estado.nombre != null ? response.data.estado.nombre : "N/A";
                addressModel.value.municipality = response.data.municipio.nombre != null ? response.data.municipio.nombre : "N/A";

                list_suburb.value = response.data.colonias;
                isLoading.value = false;


            }).catch( error =>{
                console.log(error);
                addressModel.value.city = "";
                addressModel.value.state = "";
                addressModel.value.municipality = "";
                list_suburb.value = [];
                isLoading.value = false;
            });
        }

        function execute_validation() {
          _addressModelValidation$.value.$validate();
          if(_addressModelValidation$.value.$error){
            return false;
          }
          return addressModel.value;
        }


        return {
            addressModel,
            _addressModelValidation$,
            searsh_suburb,
            list_suburb,
            execute_validation,
            isLoading
        }
    }
});
</script>